<template>
  <div class="bg-main-text">
    <div
      class="flex flex-wrap-reverse items-center footer z-20  mx-auto h-auto  card-container"
    >
      <div
        class="w-full lg:w-2/3 xl:w-2/3 lg:mt-10 xl:mt-10 text-10px lg:text-xs xl:text-xs"
      >
        <div
          class="w-full flex justify-start items-center font-semibold mb-4 flex-wrap"
        >
          <p
            class="text-white  hover:underline  iphone-font outline-none  cursor-pointer mr-10% pb-2 lg:pb-0 xl:pb-0"
          >
            <a
              href="https://partners.mozgo.com/?utm_source=mozgocom"
              class="text-white no-underline"
            >
              Купить франшизу</a
            >
          </p>
          <p
            @click.prevent="$router.push('/timetable')"
            class="text-white  hover:underline  iphone-font outline-none  cursor-pointer mr-10% pb-2 lg:pb-0 xl:pb-0"
          >
            Расписание
          </p>
          <a
            href="https://corp.mozgo.com?utm_source=mozgo"
            class="block text-white  hover:underline  iphone-font no-underline cursor-pointer mr-10%"
            >Заказать корпоратив</a
          >
          <a
            href="https://party.mozgo.com/"
            class="text-white  hover:underline no-underline iphone-font outline-none cursor-pointer"
          >
            MozgoParty</a
          >
        </div>

        <div
          class="w-full flex justify-start content-baseline font-semibold flex-wrap"
        >
          <a
            :href="`/userAgr.pdf?${hash}`"
            target="_blank"
            class="font-normal block text-white  iphone-font lg:text-xs xl:text-xs font-normal no-underline flex lg:justify-center xl:justify-center hover:underline cursor-pointer mb-2 mr-10%"
          >
            Пользовательское соглашение
          </a>
          <a
            :href="`/confidence.pdf?${hash}`"
            target="_blank"
            class="font-normal block text-white  iphone-font lg:text-xs xl:text-xs font-normal no-underline flex lg:justify-center xl:justify-center hover:underline cursor-pointer "
          >
            Политика обработки персональных данных
          </a>
        </div>
        <a  v-if="countryCode && countryCode.toString() === '7'"
            href="/Открытое_письмо_Мозгобойни.pdf" target="_blank"
            class="block md:w-80 mt-5 lg:mt-10 xl:mt-10 bg-main-text text-center font-semibold border border-white rounded-full outline-none text-white py-3 px-4 text-xs md:text-sm whitespace-no-wrap no-underline"
        >Открытое письмо Мозгобойни</a>
        <div
          class="flex md:flex md:justify-start items-end  mt-2 lg:mt-2 xl:mt-2"
        >
          <a
            type="text"
            href="mailto:portal@mozgo.com"
            class="block bg-main-text font-semibold border border-white rounded-full outline-none text-white py-3 px-4 sm:text-xs md:text-sm whitespace-no-wrap no-underline"
            @click.prevent="open"
            >Служба поддержки</a
          >

          <!-- social links -->
          <div class="flex mt-4">
            <a
              href="https://vk.com/mozgo_global"
              class="block rounded-full h-10 w-10 bg-white ml-4 flex justify-center items-center"
              target="blank"
            >
              <img class="h-9 w-9" src="@/assets/SVG/vk.svg" alt="" />
            </a>

            <!-- <a
              href="https://www.facebook.com/mozgobojglobal"
              class="block rounded-full h-10 w-10 bg-white ml-4 flex justify-center items-center"
              target="blank"
            >
              <img class="h-5 w-5" src="@/assets/SVG/fb.svg" alt="" />
            </a>

            <a
              href="https://instagram.com/mzgb_global"
              class="block rounded-full h-10 w-10 bg-white ml-4 flex justify-center items-center"
              target="blank"
            >
              <img class="h-5 w-5" src="@/assets/SVG/instagram.svg" alt="" />
            </a> -->
          </div>

          <!--
                    <div class="h-1 w-40 relative hide-element">
                        <div class="absolute pin-t -mt-16 ml-2 overflow-hidden">
                            <img src="@/assets/SVG/arrow-footer.svg" class="-mb-8" alt="" />
                        </div>
                        <p class="text-2xl text-white absolute pin-r -mr-40 caveat">Мы в Instagram :)</p>

                    </div>
                    -->
        </div>
        <div class="my-5">
          <p class="text-white ">© ООО "Квиз Мозгобойня", 2019-{{ new Date().getFullYear() }}</p>
        </div>
          <div class="text-transparent">VK:58587</div>
      </div>

      <div
        class="flex lg:justify-end xl:justify-end items-center w-1/5 lg:ml-auto xl:ml-auto lg:w-1/3 xl:w-1/3 my-2"
      >
        <img
          class="h-6 lg:h-full xl:h-full"
          src="@/assets/SVG/footer_logo.svg"
          alt=""
        />
      </div>
    </div>
    <supportModal
      v-if="openSupportModal"
      @closeSupportModal="close"
    ></supportModal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import supportModal from '../../views/modals/support-modal.vue';

const uuidv4 = require('uuid/v4');

export default {
  name: 'home-footer',
  components: {
    supportModal,
  },
  data() {
    return {
      hash: uuidv4(),
      openSupportModal: false,
    };
  },
  methods: {
    open() {
      this.openSupportModal = true;
    },
    close() {
      this.openSupportModal = false;
    },
  },
  computed: {
    ...mapState({
      countryCode: state => state.user.cityProps.phone_code,
    }),
  },
};
</script>

<style scoped>
@font-face {
  font-family: Caveat-Regular;
  src: url(../../assets/fonts/Caveat-Regular.ttf);
}

.caveat {
  font-family: Caveat-Regular;
}

@media only screen and (min-width: 319px) and (max-width: 330px) {
  .footer {
    height: 10.375rem;
    background-color: #333333;
  }
  .iphone-font {
    font-size: 0.65rem !important;
  }
}
@media only screen and (min-width: 330px) and (max-width: 600px) {
  .footer {
    height: 10.375rem;
    background-color: #333333;
  }
}

@media only screen and (min-width: 600px) {
  .footer {
    height: 9.375rem;
    background-color: #333333;
  }
}

@media only screen and (min-width: 768px) {
  .footer {
    height: 9.375rem;
    background-color: #333333;
  }
}

@media only screen and (min-width: 992px) {
  .footer {
    height: 9.375rem;
    background-color: #333333;
  }
}

@media only screen and (min-width: 1200px) {
  .footer {
    height: 9.375rem;
    background-color: #333333;
  }
}

@media (max-width: 767px) {
  .hide-element {
    display: none;
  }
}

input::-moz-placeholder {
  @apply text-white;
  color: white;
}

.card-container {
  width: 80%;
}

/* @media only screen and (min-width: 319px) and (max-width: 330px) {
  .card-container {
    max-width: 290px;
  }
}

@media only screen and (min-width: 400px) and (max-width: 600px) {
  .card-container {
    max-width: 380px;
  }
}
@media only screen and (min-width: 330px) and (max-width: 400px) {
  .card-container {
    max-width: 330px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 767px) {
  .card-container {
    max-width: 345px;
  }
} */

@media (max-width: 768px) {
  .card-container {
    width: 90%;
  }
}
</style>
